/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import React from "react";

import { Breadcrumb } from "components/atoms/Breadcrumb";
import { SubContentsLayout } from "ui/SubContentsLayout";
import { TermSidebar } from "features/terms/TermSidebar";

export const CmsTermsOfService: React.FC = () => {
  const classes = styles();

  return (
    <SubContentsLayout>
      <Breadcrumb
        // @ts-expect-error TS2322
        paths={[
          ["/", "ホーム"],
          [null, "コンテンツマネジメントシステム利用規約"],
        ]}
      />

      <div css={classes.root}>
        {/* サイドバーを表示する */}
        <TermSidebar />

        {/* コンテンツを表示する */}
        <div css={classes.main}>
          <iframe
            title="コンテンツマネジメントシステム利用規約"
            src="https://docs.google.com/document/d/e/2PACX-1vTJI6-69kPqaFQnSzclKh6gMoZ4AhtXX1jxrMOOSOUF5w-N8wR9CS0yWTrDlFiHRQ/pub?embedded=true"
          ></iframe>
        </div>
      </div>
    </SubContentsLayout>
  );
};

const styles = () => {
  return {
    root: css`
      display: grid;
      grid-template-columns: 100%;
      grid-gap: 16px;
      width: 90%;
      max-width: 1140px;
      padding: 80px 0;
      margin: 0 auto;
      @media screen and (min-width: 768px) {
        grid-template-columns: 320px auto;
      }
    `,
    main: css`
      position: relative;
      width: 100%;
      iframe {
        width: 100%;
        height: 1000px;
      }
    `,
  };
};
